import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import "../pages/FO/PageInscriptionEnCours.scss";
import imgInscription from "../images/inscription-illustration.svg";

interface CpntInscriptionStatusProps {
  title: string;
  messages: string[];
  imgAlt?: string;
}

const CpntInscriptionStatus: React.FC<CpntInscriptionStatusProps> = ({ 
  title, 
  messages, 
  imgAlt = "Inscription" 
}) => {
  const navigate = useNavigate();

  const handleRetourAccueil = () => {
    navigate("/");
  };

  return (
    <div className="page-inscription-en-cours">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <div className="inscription-status-card">
              <div className="row align-items-center">
                <div className="col-md-5 text-center mb-4 mb-md-0">
                  <div className="illustration-container">
                    <img src={imgInscription} alt={imgAlt} className="inscription-illustration" />
                  </div>
                </div>
                
                <div className="col-md-7">
                  <div className="content-container">
                    <h1 className="status-title">{title}</h1>
                    
                    <div className="status-message">
                      {messages.map((message, index) => (
                        <p key={index}>{message}</p>
                      ))}
                    </div>
                    
                    <div className="action-container">
                      <Button 
                        className="btn-retour-accueil" 
                        onClick={handleRetourAccueil}
                      >
                        Retour à la page d&apos;accueil
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CpntInscriptionStatus;
